import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from '../../helper/Icon';
import './NormalButton.css';

class NormalButton extends Component {
  renderIcon = (icon) => {
    if (!icon) {
      return null;
    }

    if (React.isValidElement(icon)) {
      return icon;
    }

    const { className } = icon;
    const iconProps = icon.iconProps || {};
    const { iconFillClassName } = this.props;
    return (
      <Icon
        icon={icon.name}
        className={classnames(iconFillClassName, 'normal-button-icon', className)}
        {...iconProps}
      />
    );
  };

  render() {
    const {
      text,
      icon,
      iconPosition,
      className,
      style,
      textColorClassName,
      disabled,
      onClick
    } = this.props;
    const classSet = classnames(
      'normal-button',
      textColorClassName,
      {
        'normal-button-disabled': disabled,
        'theme--disabled-opacity': disabled
      },
      className
    );
    return (
      <button className={classSet} style={style} onClick={!disabled && onClick}>
        {iconPosition === 'left' && this.renderIcon(icon)}
        {text}
        {iconPosition === 'right' && this.renderIcon(icon)}
      </button>
    );
  }
}

NormalButton.propTypes = {
  type: PropTypes.oneOf(['normal', 'linked']),
  text: PropTypes.string,
  icon: PropTypes.oneOfType([
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      className: PropTypes.string,
      iconProps: PropTypes.object
    }),
    PropTypes.element
  ]),
  iconPosition: PropTypes.oneOf(['left', 'right']),
  style: PropTypes.object,
  className: PropTypes.string,
  textColorClassName: PropTypes.string,
  iconFillClassName: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};

NormalButton.defaultProps = {
  type: 'normal',
  text: '',
  icon: null,
  iconPosition: 'left',
  style: {},
  className: '',
  textColorClassName: 'theme--color-primary',
  iconFillClassName: 'theme--fill-primary',
  onClick: () => {},
  disabled: false
};

export default NormalButton;
